import gql from 'graphql-tag';

export default gql`
  fragment prospectPoolTotalScoreRankProspectStandardItemHistoryFragment on ProspectPoolTotalScoreRankProspectStandardItemHistory {
    id
    fieldType
    direction
    fieldName
    fromScore
    toScore
    prospectPoolTotalScoreRankHistoryId
    createdAt
    updatedAt
  }
`;